export const GET_PERSON_SUCCESS = 'GET_PERSON_SUCCESS'
export const GET_PERSON_FAILED = 'GET_PERSON_FAILED'
export const GET_PERSON_START = 'GET_PERSON_START'